<app-base-entry-page-template entryTitle="Submit a Ticket" [value]="value" [formGroupRef]="formGroupRef" [showFooter]="selectedTabIndex < 2"
                              [isSaving]="isSaving" (saveClick)="onSaveClicked()" saveText="Save/Submit" (cancelClick)="onCancelClicked()">
  <app-base-entry-page-content-template>
    <app-ticket-form
      [(selectedTabIndex)]="selectedTabIndex"
      [(formGroupRef)]="formGroupRef"
      [(value)]="value">
    </app-ticket-form>
  </app-base-entry-page-content-template>
</app-base-entry-page-template>
